import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Add auth token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  exchangeSession: (sessionId) => API.post('/auth/session', { session_id: sessionId }),
  getMe: () => API.get('/auth/me'),
  logout: () => API.post('/auth/logout'),
  githubAuth: (data) => API.post('/auth/github', data),
  githubConfig: () => API.get('/auth/github/config'),
};

// Agents
export const agentAPI = {
  list: () => API.get('/agents'),
  get: (id) => API.get(`/agents/${id}`),
  execute: (id, data) => API.post(`/agents/${id}/execute`, data),
  history: (id) => API.get(`/agents/${id}/history`),
};

// User
export const userAPI = {
  dashboard: () => API.get('/user/dashboard'),
  getApiKeys: () => API.get('/user/api-keys'),
  addApiKey: (data) => API.post('/user/api-keys', data),
  deleteApiKey: (id) => API.delete(`/user/api-keys/${id}`),
};

// Payments
export const paymentAPI = {
  checkout: (data) => API.post('/payments/checkout', data),
  status: (sessionId) => API.get(`/payments/status/${sessionId}`),
};

// LLM
export const llmAPI = {
  providers: () => API.get('/llm/providers'),
};

// Platform
export const platformAPI = {
  liveStats: () => API.get('/platform/live-stats'),
};

// Founder Cockpit (owner-only)
export const founderAPI = {
  cockpit: () => API.get('/founder/cockpit'),
  activity: (limit = 18) => API.get(`/founder/activity?limit=${limit}`),
};

// Payments
export const paymentsAPI = {
  methods: () => API.get('/payments/methods'),
  checkout: (data) => API.post('/payments/checkout', data),
  status: (sessionId) => API.get(`/payments/status/${sessionId}`),
  razorpayVerify: (data) => API.post('/payments/razorpay/verify', data),
};

export default API;

// Admin
export const adminAPI = {
  stats: () => API.get('/admin/stats'),
  users: (skip = 0, limit = 50, search = '') => API.get(`/admin/users?skip=${skip}&limit=${limit}&search=${search}`),
  updateUser: (userId, data) => API.put(`/admin/users/${userId}`, data),
  agents: () => API.get('/admin/agents'),
  updateAgent: (agentId, data) => API.put(`/admin/agents/${agentId}`, data),
  payments: (skip = 0, limit = 50) => API.get(`/admin/payments?skip=${skip}&limit=${limit}`),
  settings: () => API.get('/admin/settings'),
  updateSettings: (data) => API.put('/admin/settings', data),
  promote: (email) => API.post('/admin/promote', { email }),
};
